<script setup lang="ts">
import { RouterView } from "vue-router";
import ShortcutSheet from "./components/ShortcutSheet.vue";
</script>

<template>
  <RouterView />
  <ShortcutSheet />
</template>
